const INTENT_SET = new Set([
  'profitability_guide',
  'property_value',
  'property_sale',
  'legacy_owner_response',
]);
const STATUS_SET = new Set(['active', 'disabled', 'missing']);

function requireString(value, label) {
  if (typeof value !== 'string' || !value.trim()) {
    throw new Error(`${label} is required.`);
  }
  return value.trim();
}

function forbidTokenFields(src) {
  for (const key of Object.keys(src || {})) {
    if (/token/i.test(key) && key !== 'status') {
      // allowlisted responses never include FCM token fields
      if (key === 'token' || key === 'tokenHash') {
        throw new Error('Push response leaked token field.');
      }
    }
  }
}

export function parseRegisterAdminProspectPushDevice(data) {
  const src = data && typeof data === 'object' ? data : {};
  forbidTokenFields(src);
  return {
    ok: src.ok === true,
    installationId: requireString(src.installationId, 'installationId'),
    status: requireString(src.status, 'status'),
    registrationGeneration: Number.isInteger(src.registrationGeneration)
      ? src.registrationGeneration
      : null,
    enrolledAt: typeof src.enrolledAt === 'string' ? src.enrolledAt : null,
    lastClientOperationId:
      typeof src.lastClientOperationId === 'string' ? src.lastClientOperationId : null,
    stale: src.stale === true,
  };
}

export function parseUnregisterAdminProspectPushDevice(data) {
  const src = data && typeof data === 'object' ? data : {};
  forbidTokenFields(src);
  return {
    ok: src.ok === true,
    installationId: requireString(src.installationId, 'installationId'),
    status: requireString(src.status, 'status'),
    registrationGeneration: Number.isInteger(src.registrationGeneration)
      ? src.registrationGeneration
      : null,
    stale: src.stale === true,
  };
}

export function parseGetAdminProspectPushDeviceStatus(data) {
  const src = data && typeof data === 'object' ? data : {};
  forbidTokenFields(src);
  const status = requireString(src.status, 'status');
  if (!STATUS_SET.has(status)) throw new Error('status is invalid.');
  return {
    ok: src.ok === true,
    installationId: requireString(src.installationId, 'installationId'),
    status,
    registrationGeneration: Number.isInteger(src.registrationGeneration)
      ? src.registrationGeneration
      : null,
    enrolledAt: typeof src.enrolledAt === 'string' ? src.enrolledAt : null,
    locale: src.locale === 'en' || src.locale === 'fr' ? src.locale : null,
    lastClientOperationId:
      typeof src.lastClientOperationId === 'string' ? src.lastClientOperationId : null,
  };
}

export function parseResolveAdminProspectPushRef(data) {
  const src = data && typeof data === 'object' ? data : {};
  const intent = requireString(src.intent, 'intent');
  if (!INTENT_SET.has(intent)) throw new Error('intent is invalid.');
  return {
    prospectId: requireString(src.prospectId, 'prospectId'),
    campaignId: requireString(src.campaignId, 'campaignId'),
    mailingId: requireString(src.mailingId, 'mailingId'),
    intent,
  };
}
